import beijing from './BD-09/beijing.js'
import qinhuangdao from './BD-09/qinhuangdao.js'
import tianjin from './BD-09/tianjin.js'
import sanya from './BD-09/sanya.js'
import nanjing from './BD-09/nanjing.js'
import hefei from './BD-09/hefei.js'
import changchun from './GCJ-02/changchun.js'
import dalian from './GCJ-02/dalian.js'
import dongying from './GCJ-02/dongying.js'
import qingdao from './GCJ-02/qingdao.js'
import shenyang from './GCJ-02/shenyang.js'
import weihai from './GCJ-02/weihai.js'
import yantai from './GCJ-02/yantai.js'

var allData = [
    {
        city: beijing,
        name: '北京市',
        type: 'BD-09'
    },
    {
        city: tianjin,
        name: '天津市',
        type: 'BD-09'
    },
    {
        city: sanya,
        name: '三亚市',
        type: 'BD-09'
    },
    {
        city: qinhuangdao,
        name: '秦皇岛市',
        type: 'BD-09'
    },
    {
        city: nanjing,
        name: '南京市',
        type: 'BD-09'
    },
    {
        city: hefei,
        name: '合肥市',
        type: 'BD-09'
    },
    {
        city: shenyang,
        name: '沈阳市',
        type: 'GCJ-02'
    },
    {
        city: changchun,
        name: '长春市',
        type: 'GCJ-02'
    },
    {
        city: dalian,
        name: '大连市',
        type: 'GCJ-02'
    },
    {
        city: dongying,
        name: '东营市',
        type: 'GCJ-02'
    },
    {
        city: qingdao,
        name: '青岛市',
        type: 'GCJ-02'
    },
    {
        city: weihai,
        name: '威海市',
        type: 'GCJ-02'
    },
    {
        city: yantai,
        name: '烟台市',
        type: 'GCJ-02'
    }
]

export default allData
